import styled from '@emotion/styled';
import { fontFamily } from 'components/views/default';
import { disabledColor, disabledLineColor } from 'components/views/default/color';

export const DriveModeButton = styled.button({
    color: '#fff',
    fontFamily,
    fontSize: '18px',
    backgroundColor: '#5bc0de',
    borderColor: '#46b8da',
    ':hover': {
        backgroundColor: '#31b0d5',
        borderColor: '#269abc',
    },
    borderRadius: '6px',
    width: '100%',
    height: '18%',
    ':focus': {
        outline: 'unset',
    },
    ':disabled': {
        color: disabledLineColor,
        backgroundColor: disabledColor,
        borderColor: disabledColor,
    }
});

export type DriveModeButtonProps = typeof DriveModeButton;
